import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFoundPage() {
  return (
    <div
      data-testid="not-found-page"
      className="mx-auto max-w-xl px-6 py-24 text-center"
    >
      <div className="text-8xl font-black text-[#00953B]/20 leading-none">
        404
      </div>
      <h1 className="mt-4 text-3xl font-black tracking-tight">
        Página no encontrada
      </h1>
      <p className="mt-2 text-neutral-500">
        El enlace que has seguido no existe o ya no está disponible.
      </p>
      <Button
        asChild
        className="mt-8 rounded-full bg-[#00953B] hover:bg-[#007a30] text-white"
      >
        <Link to="/" data-testid="not-found-home-btn">
          Volver a inicio
        </Link>
      </Button>
    </div>
  );
}
